/**
 * Created by staffanrantzow on 16/06/16.
 */

class WorkerEntity {

  constructor (
    id,
    accountClearingNumber,
    accountNumber,
    bic,
    cellphone,
    city,
    co,
    country,
    createdAt,
    defaultTaxkeyId,
    displayHsd,
    email,
    firstName,
    iban,
    internationalAccount,
    lastLogin,
    lastName,
    notificationLanguage,
    preferredPaymentTypeId,
    professionTitle,
    professionId,
    saveItp,
    itpRate,
    saveVacationPay,
    socialSecurityNumber,
    street,
    userIdOwner,
    zip
  ) {
    this.id = id;
    this.accountClearingNumber = accountClearingNumber;
    this.accountNumber = accountNumber;
    this.bic = bic;
    this.cellphone = cellphone;
    this.city = city;
    this.co = co;
    this.country = country;
    this.createdAt = createdAt;
    this.defaultTaxkeyId = defaultTaxkeyId;
    this.displayHsd = displayHsd;
    this.email = email;
    this.firstName = firstName;
    this.fullNamePersonalCode = firstName + ' ' + lastName + ' (' + socialSecurityNumber + ')';
    this.iban = iban;
    this.internationalAccount = internationalAccount;
    this.lastLogin = lastLogin;
    this.lastName = lastName;
    this.notificationLanguage = notificationLanguage;
    this.preferredPaymentTypeId = preferredPaymentTypeId;
    this.professionTitle = professionTitle;
    this.professionId = professionId;
    this.saveItp = saveItp;
    this.itpRate = itpRate;
    this.saveVacationPay = saveVacationPay;
    this.socialSecurityNumber = socialSecurityNumber;
    this.street = street;
    this.userIdOwner = userIdOwner;
    this.zip = zip;
  }
}

export default WorkerEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/workers/worker-entity.js
 **/